import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetAllActiveProjectsRPC } from "./getAllActiveProjectsRPC";

export class GetAllActiveProjectsRPCClientImpl extends GetAllActiveProjectsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetAllActiveProjectsRPC.Request): Promise<LeoRPCResult<GetAllActiveProjectsRPC.Response, GetAllActiveProjectsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "project/GetAllActiveProjects",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetAllActiveProjectsRPC.ResponseDTO,
      GetAllActiveProjectsRPC.Errors.ErrorsDTO,
      GetAllActiveProjectsRPC.Response,
      GetAllActiveProjectsRPC.Errors.Errors
    >(
      response,
      "project/GetAllActiveProjects",
      GetAllActiveProjectsRPC.Response.fromDTO,
      GetAllActiveProjectsRPC.Errors.fromDTO
    );
  }
}
